module.exports = __webpack_public_path__ + "img/icon12.c5d755e6.png";